var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-2h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M16 8.527a1 1 0 0 1 2 0v6.59A2.882 2.882 0 0 1 15.118 18H2.882A2.882 2.882 0 0 1 0 15.118V2.882A2.882 2.882 0 0 1 2.882 0h8.406a1 1 0 0 1 0 2H2.882A.882.882 0 0 0 2 2.882v12.236c0 .487.395.882.882.882h12.236a.882.882 0 0 0 .882-.882v-6.59zM17.285.318a.995.995 0 0 1 1.393-.063c.403.363.431.98.064 1.377L8.482 12.75a.995.995 0 0 1-1.426.033l-3.15-3.114a.967.967 0 0 1 0-1.379.995.995 0 0 1 1.395 0l2.42 2.392L17.285.318z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTasks);
export default __webpack_public_path__ + "static/media/icon-tasks.a89c61e2bd0e061c7be430a5b95753cd.svg";
export { ForwardRef as ReactComponent };